import { render, staticRenderFns } from "./oil.vue?vue&type=template&id=6369aa9c&scoped=true&"
import script from "./oil.vue?vue&type=script&lang=js&"
export * from "./oil.vue?vue&type=script&lang=js&"
import style0 from "./oil.vue?vue&type=style&index=0&id=6369aa9c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6369aa9c",
  null
  
)

export default component.exports